import * as React from 'react';

import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';

import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick} >
                <DataColumn kid='column1' name='Codice' fieldName='code' minWidth={120} maxWidth={120} align='left' />
                <DataColumn kid='column2' name='Ragione Sociale' fieldName='businessName' minWidth={250} align='left' />
                <DataColumn kid='column3' name='Email' fieldName='email' minWidth={250} align='left' />
                <DataColumn kid='column3' name='Dipendenti Attivi' fieldName='activeEmployees' minWidth={100} maxWidth={100} align='right' />
                <DataColumn kid='column4' name='Attivo' type="icon" fieldName='leap_CorporationStateID' minWidth={120} maxWidth={120} align='center' />
            </DataList>
        </>
    );
}
